import React, { CSSProperties, FC, PropsWithChildren } from 'react';

export const StopPropagation: FC<PropsWithChildren<{ className?: string; style?: CSSProperties }>> = ({ children, className, style }) => {
  return (
    <span className={className} style={style} onClick={(e) => e.stopPropagation()}>
      {children}
    </span>
  );
};
